export type ProofStatus = 'pending' | 'validated';

export const isProofStatus = (
  value: string | null | undefined,
): value is ProofStatus => value === 'pending' || value === 'validated';
